var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"isEmbed",attrs:{"id":"embed"}},[_c('FlashMessage'),_c('FlashNotifications'),_c('ToastNotifications'),_c('transition',{attrs:{"name":"pagefade"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }